/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/lang';
import store from '@/store'; // Import your Vuex store

Vue.use(VueI18n);

const url = new URL(window.location.href);
const queryLanguage = url.searchParams.get('lang');

const navigatorLanguage = (navigator.language.split('-')[0] || '').toLowerCase();

const defaultLanguage = 'de';

const lang = queryLanguage || navigatorLanguage || defaultLanguage;

store.commit('app/setField', { field: 'language', value: lang });

const i18n = new VueI18n({
  locale: store.state.app.language || lang,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
